<script setup>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import ModalBase from "@/components/modal/ModalBase.vue";
import ArgonLoadingButton from "@/components/ArgonLoadingButton.vue";
import ArgonSnackbar from "@/components/ArgonSnackbar.vue";

const props = defineProps({
  modalId: { type: String, required: true },
  instructions: { type: String, default: "" },
});

const emit = defineEmits(["close", "confirm"]);

const modalRouteStopInstructions = ref(null);
const instructionsTextarea = ref(null);
const vuexStore = useStore();
const bootstrap = vuexStore.state.bootstrap;

const snackbar = ref(null);
const isSubmitting = ref(false);
const form = ref({
  instructions: props.instructions || "",
});

function closeSnackbar() {
  snackbar.value = null;
}

function handleHide() {
  isSubmitting.value = false;
  emit("close");
}

function confirmSave() {
  if (isSubmitting.value) return;

  isSubmitting.value = true;
  closeSnackbar();
  emit("confirm", { instructions: form.value.instructions.trim() });
  modalRouteStopInstructions.value?.closeModal();
}

onMounted(() => {
  const modalElement = document.getElementById(props.modalId);
  const modal = new bootstrap.Modal(modalElement, {
    keyboard: true,
    backdrop: true,
  });
  modalElement.addEventListener("shown.bs.modal", () => {
    instructionsTextarea.value?.focus();
  });
  modal.show();
});
</script>

<template>
  <modal-base
    :id="modalId"
    ref="modalRouteStopInstructions"
    width="30rem"
    @hide="handleHide"
  >
    <template #header>
      <h6 class="mb-0">Instrucciones del jefe de tráfico</h6>
    </template>
    <template #body>
      <div class="row">
        <div class="col">
          <textarea
            id="route-stop-instructions"
            ref="instructionsTextarea"
            v-model="form.instructions"
            class="form-control"
            rows="2"
            maxlength="120"
            placeholder="Instrucciones para el mensajero, visibles en el detalle del servicio de la PDA."
          ></textarea>
        </div>
      </div>
    </template>

    <template #footer>
      <argon-loading-button
        class="btn bg-gradient-primary btn-xs"
        color="primary"
        variant="gradient"
        :label="isSubmitting ? 'Guardando...' : 'Guardar'"
        :loading="isSubmitting"
        :disable-button="isSubmitting"
        @click="confirmSave"
      />
    </template>

    <div class="position-fixed top-0 end-0 z-index-2 p-3">
      <argon-snackbar
        v-if="snackbar"
        :title="snackbar.title"
        :description="snackbar.message"
        :icon="{ component: 'ni ni-notification-70', color: snackbar.type }"
        :color="snackbar.color"
        :close-handler="closeSnackbar"
      />
    </div>
  </modal-base>
</template>
